import { render, staticRenderFns } from "./UpgradePlano.vue?vue&type=template&id=16638544"
import script from "./UpgradePlano.vue?vue&type=script&lang=js"
export * from "./UpgradePlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports